/* RESPONSIBLE TEAM: team-reporting */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';
import { inject as service } from '@ember/service';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';
import { taskFor } from 'ember-concurrency-ts';
import type IntlService from 'ember-intl/services/intl';
import type RouterService from '@ember/routing/router-service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class NewOverviewRoute extends IntercomRoute {
  @service intl!: IntlService;
  @service appService: $TSFixMe;
  @service declare router: RouterService;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;
  @service declare intercomEventService: any;
  @service declare navbarCollapsingService: $TSFixMe;
  @service declare aiAgentSetupService: AiAgentSetupService;
  analytics = { place: 'new-overview' };
  reportName = 'overview_report_v2';
  reportContext = 'overview';
  titleToken = this.intl.t('reporting.overview.title');

  activate() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: this.reportName,
      context: this.reportContext,
    });
    this.intercomEventService.trackEvent('viewed_overview_report');

    if (this.navbarCollapsingService.collapsed) {
      this.navbarCollapsingService.toggleNavbarCollapsed();
    }
  }

  async beforeModel() {
    let promises = [
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.workflow_conversation_rating.workflow_id',
        'conversation',
        true,
      ),
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.fin.guidelines_applied.guideline_ids',
        'conversation',
        true,
      ),
    ];

    if (this.appService.app.canUseFeature('fin-escalation-rules')) {
      promises.push(
        taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
          'conversation.fin.escalation_rules_applied.escalation_rule_ids',
          'conversation',
          true,
        ),
      );
    }

    if (this.appService.app.canSeeCxV2) {
      promises.push(
        taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
          'conversation_custom_fields#customer_experience_attributes',
          'conversation',
          true,
        ),
      );
    }

    await Promise.all(promises);

    await this.aiAgentSetupService.load();
  }

  async model() {
    return {
      conversationAttributeDescriptors: ConversationAttributeDescriptor.peekAllAndMaybeLoad(),
    };
  }
}
